import React, { useState, useEffect } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, VStack, Text, Flex, Badge,
} from '@chakra-ui/react';
import api from '../api';

export default function ViewSelectorModal({ isOpen, onClose, activeViewId, onApply }) {
  const [views, setViews] = useState([]);

  useEffect(() => {
    if (isOpen) {
      api.get('/view-filters').then(({ data }) => setViews(data)).catch(() => {});
    }
  }, [isOpen]);

  const handleSelect = (view) => { onApply(view); onClose(); };
  const handleDefault = () => { onApply(null); onClose(); };
  const handleShowAll = () => { onApply('__show_all__'); onClose(); };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalOverlay /><ModalContent>
        <ModalHeader fontSize="md">Select View</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={1} align="stretch">
            <Flex p={2} border="1px" borderRadius="md" cursor="pointer"
              borderColor={!activeViewId ? 'blue.400' : 'gray.100'}
              bg={!activeViewId ? 'blue.50' : 'white'}
              onClick={handleDefault} align="center" gap={2}>
              <Text fontSize="12px" fontWeight="600">Default View</Text>
            </Flex>
            <Flex p={2} border="1px" borderRadius="md" cursor="pointer"
              borderColor={activeViewId === '__show_all__' ? 'green.400' : 'gray.100'}
              bg={activeViewId === '__show_all__' ? 'green.50' : 'white'}
              onClick={handleShowAll} align="center" gap={2}>
              <Text fontSize="12px" fontWeight="600">Show All</Text>
              <Badge fontSize="7px" colorScheme="green">Every Row Group</Badge>
            </Flex>
            {views.map(v => (
              <Flex key={v.id} p={2} border="1px" borderRadius="md" cursor="pointer"
                borderColor={activeViewId === v.id ? 'blue.400' : 'gray.100'}
                bg={activeViewId === v.id ? 'blue.50' : 'white'}
                onClick={() => handleSelect(v)} align="center" gap={2}>
                <Text fontSize="12px" fontWeight="600">{v.name}</Text>
                {/* `v.is_system && <Badge/>` renders the literal `0` when
                    is_system comes back from MySQL as a tinyint 0 — React
                    only treats false/null/undefined as no-render, but 0
                    short-circuits the conjunction and gets stringified
                    inline. Coercing to boolean fixes the stray "0" that
                    appeared after every user-created view in the picker. */}
                {!!v.is_system && <Badge fontSize="7px" colorScheme="blue">System</Badge>}
              </Flex>
            ))}
          </VStack>
        </ModalBody>
        <ModalFooter><Button size="sm" onClick={onClose}>Close</Button></ModalFooter>
      </ModalContent>
    </Modal>
  );
}
